// extracted by mini-css-extract-plugin
export default {"lettersWrapper":"TextAnimator_lettersWrapper__TYmlM","word":"TextAnimator_word__i29DR","space":"TextAnimator_space__0IpH5","letter":"TextAnimator_letter__ZCdKK"};